<template>
  <InsightsTableContainer
    tooltip-key="data-table-general"
    download-id="gender-report-table"
    :error="error"
    class="table"
    :empty-data="emptyData || noWidgetData"
    :loading="loading"
    label="Gender Data Table"
    :headers="tableHeaders"
    :rows="tableRows"
    :totals="tableTotals"
    show-passthrough-header
    :downloading="downloading"
    @download-csv="$emit('download-csv')"
  >
    <template #actions>
      <WarningWithModal
        v-if="showWarning"
        text-key="gender-warning"
      />
    </template>
  </InsightsTableContainer>
</template>

<script setup>
import InsightsTableContainer from '@/components/insights/table/InsightsTableContainer.vue';
import { computed } from 'vue';
import WarningWithModal from '@/components/shared/WarningWithModal.vue';

const props = defineProps({
  error: {
    type: Boolean,
    default: false,
  },
  loading: {
    type: Boolean,
    default: false,
  },
  emptyData: {
    type: Boolean,
    default: false,
  },
  data: {
    type: Object,
    default: () => ({}),
  },
  tableRows: {
    type: Array,
    default: () => [],
  },
  tableTotals: {
    type: Array,
    default: () => [],
  },
  downloading: {
    type: Boolean,
    default: false,
  },
});

defineEmits(['download-csv']);

const tableHeaders = [
  'Applied',
  'Screening',
  'Assessment',
  'Offer',
  'Hired',
];

const noWidgetData = computed(() => !props.tableRows.length);

const showWarning = computed(() => {
  if (props.emptyData) return false;

  const {
    male, female, unknown, declined,
  } = props.data || {};

  const totalApplied = male.review + female.review + unknown.review + declined.review;

  const unknownApplied = unknown.review || 0;

  if (!totalApplied || !unknownApplied) return false;

  if (unknownApplied / totalApplied > 0.2) return true;

  return false;
});
</script>
